import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
// 引入store
import store from './store';

// 引入 ThButton 组件
import ThButton from '@/components/ThButton.vue'

const app = createApp(App)
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 全局注册 ThButton 组件
app.component('ThButton', ThButton)

app.use(ElementPlus, {
  locale: zhCn
});
app.use(router)
app.use(store)
app.mount('#app')
